import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { noop } from 'ui-components/default-props/noop';

import { emptyArray } from 'ui-components/default-props/empty';
import { useOtherShippingOptionsStyleContext } from '../../../style-provider';

import style from '../inputs.module.less';

const BillToAccountDropdown = ({ activeParty = '', field = '', isStatic = false, options = emptyArray, updateBillToAccount = noop }) => {
  const { shouldInputsBeFullWidth, classes } = useOtherShippingOptionsStyleContext();

  const selectedOption = options.find((option) => option.value === activeParty) || options?.[0];

  const handleOnClick = ({ id, value }) => {
    updateBillToAccount(field, value, id);
  };

  if (isStatic) {
    return <div className={classnames(style['single-bill-to-text'], classes.readonlyValueSection)}>{selectedOption?.name ?? ''}</div>;
  }

  return (
    <DropdownMenu dropdownMenuShouldHaveWidthOfButton fullWidth={shouldInputsBeFullWidth}>
      <DropdownMenuToggler className={classnames(style['bigly-dropdown'], style['bill-to-account-type-dropdown'])}>
        {selectedOption?.name ?? ''}
      </DropdownMenuToggler>
      {options.map((option) => (
        <DropdownMenuItem key={option.value} onClick={() => handleOnClick(option)}>
          {option.name}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

BillToAccountDropdown.propTypes = {
  activeParty: PropTypes.string,
  field: PropTypes.string,
  isStatic: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      value: PropTypes.string,
    }),
  ),
  updateBillToAccount: PropTypes.func,
};

export default BillToAccountDropdown;
